export const upsellProduct = {
  init() {
    // @ts-expect-error Haven't defined types for window
    window.handleUpsellToggle = this.handleUpsellToggle;
    // @ts-expect-error Haven't defined types for window
    window.addUpsellProduct = this.addUpsellProduct;
    // @ts-expect-error Haven't defined types for window
    window.removeUpsellProduct = this.removeUpsellProduct;
  },
  handleUpsellToggle(checkbox: HTMLInputElement, variantId: string, source?: string) {
    if (checkbox.checked) {
      this.addUpsellProduct(variantId, 1, { _source: source });
    } else {
      this.removeUpsellProduct(variantId);
    }
  },
  async addUpsellProduct(variantId: string, quantity: number, properties: Record<string, string>) {
    console.log("addUpsellProduct", variantId);
    const result = await fetch("/cart/add.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity,
        properties,
      }),
    });
    const data = await result.json();
  },
  async removeUpsellProduct(variantId: string) {
    console.log("removeUpsellProduct", variantId);
    const result = await fetch("/cart/change.json", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        id: variantId,
        quantity: 0,
      }),
    });

    return result.json();
  },
};
